import { Countries } from "types/Models/countries";
import { array, object, string } from "yup";
import { companyFormationTypes } from "constants/companyFormationTypes";
import { USA_COUNTRY_UUID } from "constants/entity";

export const multiEntityCreation = () =>
  object({
    entityData: array().of(
      object().shape({
        country: string().required("Country is required"),
        state: string().when("country", {
          is: (countryId: string) => countryId === USA_COUNTRY_UUID,
          then: string().required("State is required"),
          otherwise: string().notRequired(),
        }),
        formationType: string().required("Formation type is required"),
        entityName: string().required("Entity name is required"),
        suffix: string().notRequired(),
      })
    ),
  });

export const brandCreationSchema = () =>
  object({
    brandName: string()
      .test({
        name: "Brand name suffixes",
        exclusive: false,
        message: "Brand name shouldn't include a suffix.",
        test: (value) => {
          const lowerCasedValue = value?.toLowerCase().trim();
          for (const suffix of companyFormationTypes) {
            if (lowerCasedValue?.endsWith(" " + suffix.toLowerCase())) {
              return false;
            }
          }
          return true;
        },
      })
      .required("Brand Name is required"),
  });
